import React from 'react';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setPlan } from '../../../store/reducers/subscriptionSlice/subscriptionSlice';

export const formatINR = (amount) => {
	return new Intl.NumberFormat('en-IN', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(amount);
};

export const calculateGST = (amount, gstRate = 18) => {
	return +((amount * gstRate) / 100).toFixed(2);
};

const PricingCard = ({ plan, billing }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const basePrice = billing === 'monthly' ? plan.monthlyPrice : plan.yearlyPrice;

	const gstAmount = calculateGST(basePrice);
	// const finalPrice = basePrice + gstAmount;

	const handleSelectPlan = () => {
		if (plan.custom) {
			navigate('/contact-sales');
			return;
		}

		dispatch(
			setPlan({
				id: plan.id || plan.title,
				title: plan.title,
				monthlyPrice: plan.monthlyPrice,
				yearlyPrice: plan.yearlyPrice,
				billing,
			}),
		);

		navigate('/checkout');
	};

	return (
		<div className="pricing-card">
			<h5 className="title">{plan.title}</h5>
			<p className="desc">{plan.description}</p>

			{/* Price */}
			<div className="price">
				{plan.custom ? (
					<p className="contact mb-5 mt-2">Contact Us</p>
				) : (
					<>
						<div className="price-main">
							₹{formatINR(basePrice)}
							<span className="duration">/{billing === 'monthly' ? 'month' : 'year'}</span>
						</div>
						{basePrice === 0 && <br />}
						{basePrice !== 0 && <div className={`gst-text`}>+ GST ₹{formatINR(gstAmount)}</div>}
					</>
				)}
			</div>

			{/* Features */}
			<ul className="features">
				{plan.features.map((item, i) => (
					<li key={i}>
						<IoMdCheckmarkCircleOutline className="icon" />
						<span>{item}</span>
					</li>
				))}
			</ul>

			{/* CTA BUTTONS */}
			<div className="btn-group-custom">
				<button
					onClick={handleSelectPlan}
					className="btn btn-primary w-100"
				>
					{plan.cta}
				</button>
				{!plan.custom && <button className="btn btn-primary w-100">Learn More</button>}
			</div>
		</div>
	);
};

export default PricingCard;
